import { Injectable } from '@angular/core';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class PKCEVerifierStorageService {
  storageKey = "verifier";

  constructor() { }

  storeVerifier(verifier) {
    localStorage.setItem(this.storageKey, verifier);
  }

  loadVerifier() {
    return localStorage.getItem(this.storageKey);
  }

  clear() {
    localStorage.removeItem(this.storageKey);
  }
}
